import InvestigationReport from "./InvestigationReport";

export default InvestigationReport;
